<template>
    <div>
        <Hero />

        <div>
            <div class="px-4 md:px-20 text-xl flex flex-col gap-y-4 mt-5">
                <p>
                    <i>"And now, brethren, I commend you to God, and to the word of his grace, which is able to build you up, and to give you an inheritance among all them which are sanctified."</i>
                </p>
                <p>
                    Our sermons are thorough, Bible-based teachings to build you up in the faith and provoke you unto love and good works.
                </p>
                <p>Download and listen to our latest sermons.</p>
            </div>

            <div>
                <div v-if="initialDataLoad">
                    <Messages class="p-4 md:px-20" />
                </div>
                <div v-else>
                    <Loader />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Hero from '../components/Sermons/Hero.vue';
import Messages from '../components/Sermons/Messages.vue'
import Loader from '../components/Loader.vue';
import { useDataStore } from '../stores/useData';
import { storeToRefs } from 'pinia';

let dataStore = useDataStore()

let { initialDataLoad } = storeToRefs(dataStore)

</script>

<style lang="scss" scoped>

</style>